import client from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export default client({
  projectId: 'l139ea83',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2022-03-08',
});
